<template>
  <div class="full-width">
    <div
      v-for="lang in lang_supports"
      :key="lang.key"
      class="d-flex justify-center align-center"
      style="height:50px"
    >
      <div class="flex-grow-0 pa-2">
        <v-img height="20px" :src="lang.icon" width="30px"></v-img>
      </div>

      <div class="flex-grow-1">
        <v-text-field
          v-bind="attrBind"
          dense
          :placeholder="$t(`lang.${lang.key}`)"
          :rules="getRule(lang)"
          type="text"
          :value="p_form[lang.key]"
          @input="onChangeValue($event, lang)"
        />
      </div>
    </div>
    <div v-if="keyTrans" class="text-body-2 pb-2">
      <i18n path="default-name">
        <template v-slot:name>
          {{ $t(keyTrans) }}
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import { lang_supports } from '@src/constant'

import FieldMixin from './field-mixin'
export default {
  components: {},
  mixins: [FieldMixin],
  props: {
    keyTrans: { type: String },
    value: { type: Object, default: () => ({}) },
    rules: { type: Array, default: () => [] },
  },
  data: () => ({
    lang_supports,
    p_form: {},
  }),
  computed: {
    currentRules() {
      return [...this.rules, ...this.defaultRules]
    },
    defaultRules() {
      let defaultRules = []
      if (this.required) {
        defaultRules.push(
          (value) =>
            !!value || this.requiredText || this.$t('validation.required')
        )
      }
      return defaultRules
    },
  },
  watch: {
    value: {
      handler(value) {
        if (typeof value == 'object') {
          this.p_form = Object.assign({}, value)
          return
        }
        this.p_form = { [this.$i18n.fallbackLocale]: value }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getRule(lang) {
      let defaultRules = []
      if (lang.required || lang.key == this.$i18n.fallbackLocale) {
        defaultRules.push(
          (value) =>
            !!value || this.requiredText || this.$t('validation.required')
        )
      }
      return [...this.rules, ...defaultRules]
    },
    onChangeValue(e, lang) {
      this.p_form[lang.key] = e
      this.$emit('input', this.p_form)
    },
  },
}
</script>

<style scoped></style>
